<script>

import MfaForm from "@/components/login/Mfa.vue";

export default {
  name: "LoginForm",
  components: {MfaForm},
  data() {
    return {
      username: '',
      password: '',
      needMfa: false,
      loginCode: "",
      btnDisabled: false
    }
  },
  methods: {
    login() {
      //点击后禁止按钮
      this.btnDisabled = true

      this.$api.adminLogin({
        username: this.username,
        password: this.password
      }).then((response) => {
        if (response.data.is_mfa) {
          this.needMfa = true
          this.loginCode = response.data.login_code
        }
      }).catch((error) => {
        alert(error)
      })
    }
  },
  mounted: function () {
    //给表单添加焦点
    this.$refs.in.focus()
  }
}
</script>

<template>
  <div class="form-area">
    <el-form size="small" @submit.prevent.native>
      <div class="pass-auth" v-if="!needMfa">
        <el-form-item label="账号">
          <el-input v-model.trim="username" placeholder="请输入账号" v-on:keyup.enter.native="login" ref="in"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model.trim="password" placeholder="请输入密码" show-password v-on:keyup.enter.native="login"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="login" :loading="this.btnDisabled">登录</el-button>
        </el-form-item>
      </div>
      <div class="mfa-auth" v-if="needMfa">
        <mfa-form v-bind:username="username" v-bind:loginCode="loginCode"></mfa-form>
      </div>
    </el-form>
  </div>
</template>

<style scoped>
  .form-area {
    width: 50%;
  }
</style>